module.exports = __webpack_public_path__ + "static/img/desktop-xmsp.1769ed9a.png";